import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { message } from 'antd';
import { useCookies } from 'react-cookie';
import { advertisementApis } from 'apis/sales/advertisementApis';
import { theme } from 'utils/style/theme';
import DefaultLayout from 'components/layout/DefaultLayout';
import TableToolbar from 'components/table/TableToolbar';
import ToggleButton from 'components/button/ToggleButton';
import DefaultInput from 'components/input/DefaultInput';
import DefaultButton from 'components/button/DefaultButton';
import InputWrappingBox from 'components/container/InputWrappingBox';
import TextFlexBox from 'components/container/TextFlexBox';
import { useTranslation } from 'react-i18next';
/**
 * * 판매 관리 - 광고 관리
 */

const AdvertisementSettingPage = () => {
  const { t } = useTranslation();
  const [cookies] = useCookies();
  const authUpdate = JSON.parse(cookies?.managementAuth);
  const [inputData, setInputData] = useState();
  const alertText = '광고 점유율 합산은 항상 100이 되어야 합니다.';

  /// 인풋
  const handleChange = (e) => {
    const { name, value, checked } = e.target;

    if (e.target.value === '') {
      setInputData({ ...inputData, [name]: checked ? 1 : 0 });
    } else {
      setInputData({ ...inputData, [name]: value });
    }
  };

  /// 서버 저장
  const handleSubmit = async () => {
    // 광고 점유율 100 % 유효성
    if (inputData?.loading_interstitial + inputData?.loading_rewarded !== 100) {
      return alert(t('advertisement.alert.episodeLoading') + alertText);
    }
    if (inputData?.play_interstitial + inputData?.play_rewarded !== 100) {
      return alert(t('advertisement.alert.inGamePlay') + alertText);
    }
    if (
      inputData?.selection_interstitial + inputData?.selection_rewarded !==
      100
    ) {
      return alert(t('advertisement.alert.selectionInterstitial') + alertText);
    }
    if (inputData?.reward_interstitial + inputData?.reward_rewarded !== 100) {
      return alert(t('advertisement.alert.5xRewardChoice') + alertText);
    }
    const res = await advertisementApis.update(inputData);
    if (!res) {
      return false;
    }
    fetchData();
    message.success(t('advertisement.alert.successSubmitMessage'), 1);
  };

  const fetchData = async () => {
    const res = await advertisementApis.read();
    setInputData(res[0]);
  };

  useEffect(() => {
    fetchData().catch(console.log);
  }, []);
  return (
    <DefaultLayout>
      <TableToolbar>
        <div
          style={{
            fontWeight: '700',
            fontSize: '1rem',
            color: `${theme.colors.gray_2}`,
          }}
        >
          {t('advertisement.header.notice')}
        </div>

        <DefaultButton onClick={handleSubmit} disabled={authUpdate}>
          {t('advertisement.header.saveButton')}
        </DefaultButton>
      </TableToolbar>
      <InputWrappingBox style={{ marginBottom: '1.2rem' }}>
        <ContentWrap>
          <h3>{t('advertisement.episodeLoadingAds.title')}</h3>
          <div className='toggle_wrap'>
            <p>{t('advertisement.episodeLoadingAds.active')}</p>
            <ToggleButton
              name='loading_is_active'
              onChange={handleChange}
              checked={inputData?.loading_is_active === 1 ? true : false}
            />
          </div>
          <div className='left_content_wrap'>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                marginBottom: '0.5rem',
              }}
            >
              <p className='text_p'>
                {t('advertisement.episodeLoadingAds.advertisementType')}
              </p>
              <p style={{ color: `${theme.colors.black}`, fontSize: '1rem' }}>
                {t(
                  'advertisement.episodeLoadingAds.advertisementTypeInterstitial',
                )}
              </p>
            </TextFlexBox>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                alignItems: 'baseline',
              }}
            >
              <p className='text_p'>
                {t('advertisement.episodeLoadingAds.advertisementRate')}
              </p>
              <DefaultInput
                name='loading_interstitial'
                value={inputData?.loading_interstitial}
                onChange={handleChange}
                type='number'
                style={{ width: 'unset' }}
              />
              <span className='span_style'>%</span>
            </TextFlexBox>
          </div>
          <div className='right_content_wrap'>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                marginBottom: '0.5rem',
              }}
            >
              <p className='text_p'>
                {t('advertisement.episodeLoadingAds.advertisementRate')}
              </p>
              <p style={{ color: `${theme.colors.black}`, fontSize: '1rem' }}>
                {t('advertisement.episodeLoadingAds.videoAd')}
              </p>
            </TextFlexBox>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                alignItems: 'baseline',
              }}
            >
              <p className='text_p'>
                {t('advertisement.episodeLoadingAds.advertisementRate')}
              </p>
              <DefaultInput
                name='loading_interstitial'
                value={inputData?.loading_rewarded}
                onChange={handleChange}
                type='number'
                style={{ width: 'unset' }}
              />
              <span className='span_style'>%</span>
            </TextFlexBox>
          </div>
        </ContentWrap>
      </InputWrappingBox>
      <InputWrappingBox style={{ marginBottom: '1.2rem' }}>
        <ContentWrap>
          <h3>{t('advertisement.inGameBannerAds.title')}</h3>
          <div className='toggle_wrap'>
            <p>{t('advertisement.inGameBannerAds.active')}</p>
            <ToggleButton
              name='banner_is_active'
              onChange={handleChange}
              checked={inputData?.banner_is_active === 1 ? true : false}
            />
          </div>
        </ContentWrap>
      </InputWrappingBox>
      <InputWrappingBox style={{ marginBottom: '1.2rem' }}>
        <ContentWrap>
          <h3>{t('advertisement.inGamePlayAds.title')}</h3>
          <div className='toggle_wrap'>
            <p>{t('advertisement.inGamePlayAds.active')}</p>
            <ToggleButton
              name='play_is_active'
              onChange={handleChange}
              checked={inputData?.play_is_active === 1 ? true : false}
            />
          </div>
          <div className='left_content_wrap'>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                marginBottom: '0.5rem',
              }}
            >
              <p className='text_p'>
                {t('advertisement.inGamePlayAds.numLines')}
              </p>
              <DefaultInput
                name='play_line'
                value={inputData?.play_line}
                onChange={handleChange}
                type='number'
                // style={{ textAlign: 'left' }}
              />
            </TextFlexBox>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                marginBottom: '0.5rem',
              }}
            >
              <p className='text_p'>
                {t('advertisement.inGamePlayAds.advertisementType')}
              </p>
              <p style={{ color: `${theme.colors.black}`, fontSize: '1rem' }}>
                {t('advertisement.inGamePlayAds.advertisementTypeInterstitial')}
              </p>
            </TextFlexBox>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                alignItems: 'baseline',
              }}
            >
              <p className='text_p'>
                {t('advertisement.inGamePlayAds.advertisementRate')}
              </p>
              <DefaultInput
                name='play_interstitial'
                value={inputData?.loading_interstitial}
                onChange={handleChange}
                type='number'
                style={{ width: 'unset' }}
              />
              <span className='span_style'>%</span>
            </TextFlexBox>
          </div>
          <div className='right_content_wrap'>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                marginBottom: '0.5rem',
              }}
            >
              <p className='text_p' style={{ width: '3rem' }}>
                {t('advertisement.inGamePlayAds.percent')}
              </p>
              <DefaultInput
                name='play_percent'
                value={inputData?.play_percent}
                onChange={handleChange}
                type='number'
                style={{ width: 'unset' }}
              />
              <span className='span_style'>%</span>
            </TextFlexBox>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                marginBottom: '0.5rem',
              }}
            >
              <p className='text_p'>
                {t('advertisement.inGamePlayAds.advertisementType')}
              </p>
              <p style={{ color: `${theme.colors.black}`, fontSize: '1rem' }}>
                {t('advertisement.inGamePlayAds.videoAd')}
              </p>
            </TextFlexBox>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                alignItems: 'baseline',
              }}
            >
              <p className='text_p'>
                {t('advertisement.inGamePlayAds.advertisementRate')}
              </p>
              <DefaultInput
                name='play_rewarded'
                value={inputData?.loading_rewarded}
                onChange={handleChange}
                type='number'
                style={{ width: 'unset' }}
              />
              <span className='span_style'>%</span>
            </TextFlexBox>
          </div>
        </ContentWrap>
      </InputWrappingBox>
      <InputWrappingBox style={{ marginBottom: '1.2rem' }}>
        <ContentWrap>
          <h3>{t('advertisement.adsFreeOptionsLimit.title')}</h3>
          <div className='toggle_wrap'>
            <p>{t('advertisement.adsFreeOptionsLimit.active')}</p>
            <ToggleButton
              name='selection_is_active'
              onChange={handleChange}
              checked={inputData?.selection_is_active === 1 ? true : false}
            />
          </div>
          <div className='left_content_wrap'>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                marginBottom: '0.5rem',
              }}
            >
              <p className='text_p'>
                {t('advertisement.adsFreeOptionsLimit.advertisementType')}
              </p>
              <p style={{ color: `${theme.colors.black}`, fontSize: '1rem' }}>
                {t(
                  'advertisement.adsFreeOptionsLimit.advertisementTypeInterstitial',
                )}
              </p>
            </TextFlexBox>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                alignItems: 'baseline',
              }}
            >
              <p className='text_p'>
                {t('advertisement.adsFreeOptionsLimit.advertisementRate')}
              </p>
              <DefaultInput
                name='selection_interstitial'
                value={inputData?.loading_interstitial}
                onChange={handleChange}
                type='number'
                style={{ width: 'unset' }}
              />
              <span className='span_style'>%</span>
            </TextFlexBox>
          </div>
          <div className='right_content_wrap'>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                marginBottom: '0.5rem',
              }}
            >
              <p className='text_p'>
                {t('advertisement.adsFreeOptionsLimit.advertisementType')}
              </p>
              <p style={{ color: `${theme.colors.black}`, fontSize: '1rem' }}>
                {t('advertisement.adsFreeOptionsLimit.videoAd')}
              </p>
            </TextFlexBox>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                alignItems: 'baseline',
              }}
            >
              <p className='text_p'>
                {t('advertisement.adsFreeOptionsLimit.advertisementRate')}
              </p>
              <DefaultInput
                name='selection_rewarded'
                value={inputData?.loading_rewarded}
                onChange={handleChange}
                type='number'
                style={{ width: 'unset' }}
              />
              <span className='span_style'>%</span>
            </TextFlexBox>
          </div>
        </ContentWrap>
      </InputWrappingBox>
      <InputWrappingBox>
        <ContentWrap>
          <h3>{t('advertisement.5xSelectionAds.title')}</h3>
          <div className='toggle_wrap'>
            <p>{t('advertisement.5xSelectionAds.active')}</p>
            <ToggleButton
              name='reward_is_active'
              onChange={handleChange}
              checked={inputData?.reward_is_active === 1 ? true : false}
            />
          </div>
          <div className='left_content_wrap'>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                marginBottom: '0.5rem',
              }}
            >
              <p className='text_p'>
                {t('advertisement.5xSelectionAds.advertisementType')}
              </p>
              <p style={{ color: `${theme.colors.black}`, fontSize: '1rem' }}>
                {t(
                  'advertisement.5xSelectionAds.advertisementTypeInterstitial',
                )}
              </p>
            </TextFlexBox>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                alignItems: 'baseline',
              }}
            >
              <p className='text_p'>
                {t('advertisement.5xSelectionAds.advertisementRate')}
              </p>
              <DefaultInput
                name='reward_interstitial'
                value={inputData?.loading_interstitial}
                onChange={handleChange}
                type='number'
                style={{ width: 'unset' }}
              />
              <span className='span_style'>%</span>
            </TextFlexBox>
          </div>
          <div className='right_content_wrap'>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                marginBottom: '0.5rem',
              }}
            >
              <p className='text_p'>
                {t('advertisement.5xSelectionAds.advertisementType')}
              </p>
              <p style={{ color: `${theme.colors.black}`, fontSize: '1rem' }}>
                {t('advertisement.5xSelectionAds.videoAd')}
              </p>
            </TextFlexBox>
            <TextFlexBox
              style={{
                color: `${theme.colors.blueText}`,
                alignItems: 'baseline',
              }}
            >
              <p className='text_p'>
                {t('advertisement.5xSelectionAds.advertisementRate')}
              </p>
              <DefaultInput
                name='reward_rewarded'
                value={inputData?.loading_rewarded}
                onChange={handleChange}
                type='number'
                style={{ width: 'unset' }}
              />
              <span className='span_style'>%</span>
            </TextFlexBox>
          </div>
        </ContentWrap>
      </InputWrappingBox>
    </DefaultLayout>
  );
};

export default AdvertisementSettingPage;

const ContentWrap = styled.div`
  display: flex;
  h3 {
    font-weight: 700;
    font-size: 1rem;
    color: ${theme.colors.blueText};
    width: 10rem;
  }
  .toggle_wrap {
    width: 8rem;
    display: flex;
    align-items: flex-start;
    p {
      font-weight: 500;
      width: 4rem;
      margin-top: 0.25rem;
    }
  }
  .left_content_wrap {
    margin-left: 3rem;
    margin-right: 6rem;
  }
  .left_content_wrap,
  .right_content_wrap {
    .text_p {
      font-weight: 600;
      margin-right: 1rem;
      font-size: 1rem;
      width: 5rem;
    }
    .span_style {
      font-size: 1rem;
      margin-left: 0.5rem;
    }
  }
`;

const TextWrap = styled.div`
  display: flex;
  align-items: center;
  span {
    margin-left: 0.5rem;
  }
`;
